<template>
    <div id="popup-container">
        <v-toolbar dark color="primary">
            <v-toolbar-title class="heading-title">Add External Training</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab x-small class="close" @click="closePanel">
                <v-icon dark>fa-times</v-icon>
            </v-btn>
        </v-toolbar>
        <v-container>
            <v-layout>
                <v-flex xs12>
                    <v-form>
                        <v-text-field
                        :error-messages="messages.name"
                        v-model="externalTraining.name"
                        label="Course Title"
                        type="text"
                        filled
                        ></v-text-field>
                        <v-select
                            v-model="externalTraining.user"
                            :error-messages="messages.user"
                            :items="users"
                            :item-text="getUserName"
                            item-value="id"
                            label="User"
                            filled
                            attach
                            :loading="isLoading"
                            :disabled="isLoading"
                            hide-no-data
                            @change="resetSearchTerm"
                        >
                        <template v-slot:prepend-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-text-field v-model="searchTerm" label="Search User" @input="searchUsers" class="search-term"></v-text-field>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                        <template #progress>
                            <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                        </template>
                    </v-select>
                        <v-menu
                        :close-on-content-click="false"
                        v-model="menuCompleted"
                        max-width="290"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :value="computedCompletedDate"
                                :error-messages="messages.completed"
                                clearable
                                label="Date Completed"
                                readonly
                                v-on="on"
                                filled
                                ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="externalTraining.completed"
                            @change="menuCompleted = false"
                            :allowed-dates="allowedDates"
                            color="calender"
                            ></v-date-picker>
                        </v-menu>
                        <CategorySelect :cat="this.category"/>
                        <v-text-field
                        :error-messages="messages.body"
                        v-model="externalTraining.body"
                        label="Institute / Body"
                        type="text"
                        filled
                        ></v-text-field>
                        <v-text-field
                        :error-messages="messages.score"
                        v-model="externalTraining.score"
                        label="Score (%)"
                        type="number"
                        :min="0"
                        :max="100"
                        @keypress="NumbersOnly"
                        @blur="handleBlur('score',100)"
                        filled
                        ></v-text-field>
                        <v-select
                        :items="computedTrainingResultOptions"
                        v-model="externalTraining.result"
                        item-value="id"
                        item-text="name"
                        label="Result"
                        filled
                        attach
                        ></v-select>
                        <v-text-field
                        :error-messages="messages.cost"
                        v-model="externalTraining.cost"
                        label="Cost (£)"
                        type="number"
                        :min="0"
                        :max="5000"
                        @keypress="NumbersOnly"
                         @blur="handleBlur('cost',5000)"
                        filled
                        ></v-text-field>
                        <v-menu
                        :close-on-content-click="false"
                        v-model="menuDeadline"
                        max-width="290"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :value="computedDeadlineDate"
                                :error-messages="messages.deadline"
                                clearable
                                label="Expiry Date"
                                readonly
                                v-on="on"
                                filled
                                ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="externalTraining.deadline"
                            @change="menuDeadline = false"
                            color="calender"
                            :allowed-dates="allowedExpiryDates"
                            ></v-date-picker>
                        </v-menu>
                        <drop-zone
                        :type="type"
                        :accepted="accepted"
                        class="mt-5 dropzone-container2"
                        ></drop-zone>
                        <p class="block text-left mt-4 caption">Max upload filesize: 10MB <br />Accepted file formats: png, jpg, pdf, docx, doc</p>
                    </v-form>
                </v-flex>
            </v-layout>
        </v-container>
        <v-footer height="68">
            <v-flex px-4 py-4 text-right>
                <div>
                    <v-btn v-if="loading" color="grey300" class="mr-4 cancel-button" loading></v-btn>
                    <v-btn v-else color="dark-blue" class="add-course-button" @click="addExternalTraining">Add External Training</v-btn>
                </div>
            </v-flex>
        </v-footer>
    </div>
</template>
<script>
    import { EventBus } from "@/event-bus.js";
    import externalAPI from "@/api/external.js";
    import userAPI from "@/api/user.js";
    import moment from "moment";
    import DropZone from "@/components/global/Dropzone";
    import CategorySelect from './CategorySelect.vue';
    export default {
        name: "AddExternalTrainingDrawer",
        components: {
            DropZone: DropZone,
            CategorySelect
        },
        props: {
            options: {
              type: Object,
              default: null
            }
        },
        data() {
            return {
                items: [],
                users: [],
                type: "certificate",
                accepted:
                  "image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                menuCompleted: false,
                menuDeadline: false,
                externalTraining: {},
                file: {},
                messages: {},
                loading: false,
                successMessage: "External Training Successfully Added.",
                errorMessage: "Oops, something went wrong! Please check information is correct.",
                trainingTypeOptions: [],
                trainingResultOptions: [
                    {
                        id: 'passed',
                        name: "Passed"
                    },
                    {
                        id: 'failed',
                        name: "Failed"
                    }
                ],
                searchTerm: "",
                usersCopy : [],
                filteredUsers: [],
                isLoading: false,
                category: null,
            };
        },
        computed: {
            s3Uploading() {
                return this.$store.getters.s3Uploading;
            },
            computedCompletedDate() {
                return this.externalTraining.completed ? moment(this.externalTraining.completed).format("dddd, MMMM Do YYYY") : "";
            },
            computedDeadlineDate() {
                return this.externalTraining.deadline ? moment(this.externalTraining.deadline).format("dddd, MMMM Do YYYY") : "";
            },
            computedTrainingResultOptions() {
                return this.trainingResultOptions.map((option) => {
                    if (this.externalTraining.score === null) return { ...option, disabled: false };

                    if (option.id === 'passed' && this.externalTraining.score < 35) {
                        return { ...option, disabled: true };
                    }

                    if (option.id === 'failed' && this.externalTraining.score >= 35) {
                    return { ...option, disabled: true };
                    }

                    return { ...option, disabled: false };
                });
            },
        },
        mounted() {
            this.$store.dispatch("setS3Uploading", false);
            this.getUsers();
            this.setEventBus();
        },
        methods: {
            closePanel() {
                this.$emit("closePanel", {});
            },
            addExternalTraining() {
                this.loading = true;
                this.externalTraining.type = this.category ? this.category.id : '';
                externalAPI
                .createAdminExternalTraining(
                    this.externalTraining,
                    this.$store.getters.s3Url,
                    this.$store.getters.fileDetails
                )
                .then(() => {
                    this.loading = false;
                    this.closePanel();
                    this.$snotify.success(this.successMessage);
                    EventBus.$emit("EXTERNAL_TRAINING_UPDATED", this.options);
                })
                .catch(err => {
                    this.loading = false;
                    this.valid = false;
                    this.messages = this.$gf.errorResponse(err);
                });
            },
            getUsers() {
                this.loading = true;
                this.isLoading = true;
                userAPI
                .getUsersWithoutPagination(
                    this.$store.getters.user.company.data.id
                )
                .then((response) => {
                    this.loading = false;
                    this.users = response.data.data;
                    this.isLoading = false;
                    this.usersCopy = [...this.users];
                })
                .catch(err => {
                    this.loading = false;
                });
            },
            getUserName(item) {
                return item.first_name + ' ' + item.last_name;
            },
            searchUsers() {
                if (!this.searchTerm) {
                    this.users = this.usersCopy; // Reset to original if search is empty
                    }

                    // Filter the array by matching the `name` property
                    this.users = this.usersCopy.filter((user) =>
                        user.full_name.toLowerCase().includes(this.searchTerm.toLowerCase())
                    );
            },
            resetSearchTerm() {
                this.searchTerm = ""; // Clear the search term
                this.users = this.usersCopy; // Reset filtered fruits
            },
            allowedDates(date) {
                const today = new Date();
                const currentYear = today.getFullYear();
                const tenYearsAgo = new Date();
                tenYearsAgo.setFullYear(currentYear - 10);

                const selected = new Date(date);
                
                // Disallow future dates
                if (selected > today) return false;

                // Allow only dates from the last 10 years
                return selected >= tenYearsAgo;
            },
            NumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            handleBlur(type, maxNumber){
                if(type == 'score'){
                    const value = parseInt(this.externalTraining.score, 10);
                    if (value > maxNumber) {
                        this.externalTraining.score = maxNumber;
                    }
                }
                if(type == 'cost'){
                    const value = parseInt(this.externalTraining.cost, 10);
                    if (value > maxNumber) {
                        this.externalTraining.cost = maxNumber;
                    }
                }
            },
            allowedExpiryDates(date){
                const today = new Date();
                const currentYear = today.getFullYear();

                const minDate = new Date();
                minDate.setFullYear(currentYear - 10);

                const maxDate = new Date();
                maxDate.setFullYear(currentYear + 10);

                const selected = new Date(date);

                return selected >= minDate && selected <= maxDate;
            },
            setEventBus() {
                EventBus.$on("SELECTED_TRAINING_CATEGORY", selectedCategory => {
                    this.category = selectedCategory;
                });
            },
        },
        watch: {
            'externalTraining.score'(newScore) {
            const current = this.externalTraining.result;

            const selectedOption = this.computedTrainingResultOptions.find(
                (opt) => opt.id === current
            );

            if (selectedOption && selectedOption.disabled) {
                this.externalTraining.result = '';
            }
            },
        },
    };
</script>
<style scoped>
.v-progress-circular{
    height: auto !important;
}
</style>